
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeTaskDialog extends Serenity.EntityDialog<UtentiProdottiEsperienzeTaskRow, any> {
        protected getFormKey() { return UtentiProdottiEsperienzeTaskForm.formKey; }
        protected getIdProperty() { return UtentiProdottiEsperienzeTaskRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeTaskService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiEsperienzeTaskRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeTaskRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiEsperienzeTaskRow.updatePermission; }

        protected form = new UtentiProdottiEsperienzeTaskForm(this.idPrefix);

    }
}